import { render, staticRenderFns } from "./TeamThree.vue?vue&type=template&id=6fdbadd2"
import script from "./TeamThree.vue?vue&type=script&lang=js"
export * from "./TeamThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports